import { createSelector } from 'reselect';
import { property, identity } from 'lodash';

export const getAbout = createSelector(property('about'), identity);
export const isLoaded = createSelector(getAbout, property('isLoaded'));
export const getError = createSelector(getAbout, property('error'));



// WEBPACK FOOTER //
// ./src/modules/AboutDetail/selectors/index.js